import { render, staticRenderFns } from "./RootCauses.vue?vue&type=template&id=12bb40ce&scoped=true&"
import script from "./RootCauses.vue?vue&type=script&lang=ts&"
export * from "./RootCauses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb40ce",
  null
  
)

export default component.exports